export default "__VITE_ASSET__DBbbA3Si__"